import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type UpsertCustomBrandingMutationVariables = Types.Exact<{
  input: Types.UpsertCustomBrandingInput;
}>;


export type UpsertCustomBrandingMutation = { __typename?: 'Mutation', upsertCustomBranding: { __typename?: 'CustomBranding', tenantId: string, tenantName?: string | null, faviconUrl?: string | null, faviconFileUuid?: string | null, logoUrl?: string | null, logoFileUuid?: string | null, primaryColor?: string | null } };

export type GetCustomBrandingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomBrandingQuery = { __typename?: 'Query', Tenant: { __typename?: 'TenantQueries', customBranding?: { __typename?: 'CustomBranding', tenantId: string, tenantName?: string | null, faviconUrl?: string | null, faviconFileUuid?: string | null, logoUrl?: string | null, logoFileUuid?: string | null, primaryColor?: string | null } | null } };


export const UpsertCustomBrandingDocument = `
    mutation upsertCustomBranding($input: UpsertCustomBrandingInput!) {
  upsertCustomBranding(input: $input) {
    tenantId
    tenantName
    faviconUrl
    faviconFileUuid
    logoUrl
    logoFileUuid
    primaryColor
  }
}
    `;
export const GetCustomBrandingDocument = `
    query getCustomBranding {
  Tenant {
    customBranding {
      tenantId
      tenantName
      faviconUrl
      faviconFileUuid
      logoUrl
      logoFileUuid
      primaryColor
    }
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    upsertCustomBranding: build.mutation<UpsertCustomBrandingMutation, UpsertCustomBrandingMutationVariables>({
      query: (variables) => ({ document: UpsertCustomBrandingDocument, variables })
    }),
    getCustomBranding: build.query<GetCustomBrandingQuery, GetCustomBrandingQueryVariables | void>({
      query: (variables) => ({ document: GetCustomBrandingDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUpsertCustomBrandingMutation, useGetCustomBrandingQuery, useLazyGetCustomBrandingQuery } = injectedRtkApi;

